import type { TrainingModule } from "../types";

/**
 * R2, radio procedure trainer. Doc 05.
 *
 * SCAFFOLD ONLY. There is no behaviour here and none is authorised: this is
 * the module folder and the one registry line, behind the `radioProcedure`
 * flag which is off by default.
 *
 * Everything doc 05 asks for is listed in `docs/plans/R2_groundwork.md`,
 * including what the architecture does not yet provide and the three places
 * doc 05 conflicts with doc 03, where doc 03 wins.
 *
 * The card states that the module is not built rather than showing an empty
 * interface, because a module that looks present and does nothing is worse
 * than one that says it is not there.
 */
export const radioProcedureModule: TrainingModule = {
  id: "radio-procedure",
  title: "Radio Procedure Trainer",
  featureFlag: "radioProcedure",
  render: () => ({
    kind: "content",
    heading: "Radio Procedure Trainer",
    body: "Not built. This is a placeholder for R2 and does nothing yet. It needs microphone capture, on-device transcription and the constrained vocabulary layer, none of which exist, and it needs the app to be on HTTPS before the microphone can be reached at all.",
  }),
};
